export const waitingRoom = (timestamp: number) => ({
  timestamp: timestamp || Date.now() + 3500,
  init() {
    const now = Date.now();
    if (now < this.timestamp) {
      const timeUntilReload = this.timestamp - now;
      setTimeout(() => location.reload(), timeUntilReload);
    }
  },
});
